const SiteDescription = () => {
    return (
        <div
            className="flex-1 hidden lg:flex lg:flex-1 bg-no-repeat bg-cover text-white justify-center items-center text-center  "
            style={{
                backgroundImage: `url("/images/login-wallpaper.jpg")`
            }}>
            <div className="flex flex-col items-center ">
                <img src="/images/RashacLogo.png" className="max-w-16" alt="" />
                <h2 className="my-3 text-mega-big font-semibold text-4xl">Rash Prime</h2>
                <h3 className="">Optimize Your Operations</h3>
                <p className="mt-8">
                    This website uses cookies to deliver the best possible user experience. With
                    signning up you are accepting this fact
                </p>
            </div>
        </div>
    );
};

export default SiteDescription;
